import React, { useState } from 'react'
import { Box, Avatar, Flex, Badge, HStack, chakra, VStack } from '@chakra-ui/react'
import CustomTable from '../../../components/BasicUI/CustomTable'
import { useDeleteUser, useUsers, useUsersFacet } from '../../../config/query/userQuery'
import { formatDateTime, formatDateTimeFromNow } from '../../../config/helpers/dateHelper'
import APP_ICONS from '../../../config/constants/icons'
import StatusBadge from '../../../components/BasicUI/Badges/StatusBadge'
import TableInfoPopover from '../../../components/BasicUI/Popovers/TableInfoPopover'
import LabelValuePair from '../../../components/BasicUI/LabelValuePair'
import { getFilters } from '../../../config/helpers/filterHelper'
import DevicesCount from '../../../components/BasicUI/Badges/DevicesCount'
import Chronology from '../../../components/BasicUI/DataBoxes/Chronology'
import { formatAddress } from '../../../config/helpers/stringHelper'

const UserList = ({ onEditModal }) => {

    const [query, setQuery] = useState({
        pageNo: 1,
        pageSize: 20,
    })

    const userQuery = useUsers(query)
    const userFacetQuery = useUsersFacet()
    const deleteUserQuery = useDeleteUser()

    const handleDelete = (id) => {
        deleteUserQuery.mutateAsync(id)
            .then((response) => {
                userQuery.refetch()
                console.log(`User deleted successfully: ${response}`)
            })
            .catch((error) => {
                console.log(`Error while deleting user: ${error}`)
            })
    }

    return (
        <CustomTable
            containerProps={{ mt: 5 }}
            searchPlaceholder="Search users"
            filters={getFilters(userFacetQuery?.data)}
            head={[
                {
                    title: "Name",
                    extractor: "name",
                    align: "left",
                    component: (item) => (
                        <TableInfoPopover
                            data={item}
                            onEdit={(item) => onEditModal(item)}
                            onDelete={(id) => handleDelete(id)}
                            triggerOnClick={() => onEditModal(item)}
                            triggerComponent={
                                <Flex p="5px 0" alignItems="center" onClick={() => onEditModal(item)} w="fit-content">
                                    <Avatar name={item.name} src={item.profilePictureUrl} />
                                    <Box ml={3}>
                                        <Box fontWeight="bold" _hover={{ textDecor: "underline" }}>{item.name}</Box>
                                        <Box fontSize="sm">{item.email}</Box>
                                    </Box>
                                </Flex>
                            }
                        >
                            <LabelValuePair label="Role" value={item.roleName} />
                            <LabelValuePair
                                label="Allowed Devices"
                                value={String(item.allowedDevices)}
                                valueComponent={
                                    <DevicesCount value={String(item.allowedDevices)} />
                                }
                            />
                            <LabelValuePair label="Description" value={item.description} />
                            <LabelValuePair
                                label="Status"
                                value={true}
                                valueComponent={<StatusBadge value={item.status} />}
                            />
                            <LabelValuePair label="Address" value={formatAddress(item)} />
                            <LabelValuePair label="Created" value={formatDateTime(item.createdBy?.dateTime)} />
                            <LabelValuePair label="Last Updated" value={formatDateTime(item.updateBy?.dateTime)} />
                        </TableInfoPopover>
                    )
                },
                { title: "Phone", extractor: "phoneNumber" },
                { title: "Allowed Devices", extractor: "allowedDevices" },
                { title: "Status", extractor: "status", component: (item) => <StatusBadge value={item.status} /> },
                {
                    title: "Last Modified",
                    extractor: "lastModified",
                    component: (item) => (<Chronology data={item} />)
                },
                { title: "Actions", extractor: "actions" }
            ]}
            data={userQuery?.data?.results?.map((item) => {
                return {
                    ...item,
                    location: `${item.city}, ${item.country}`,
                    lastModified: item.updatedBy?.dateTime ? formatDateTimeFromNow(item.updatedBy?.dateTime) : formatDateTimeFromNow(item.createdBy?.dateTime),
                    actions: [
                        {
                            title: "Edit",
                            action: () => onEditModal(item),
                            icon: APP_ICONS.EDIT,
                            isEdit: true
                        },
                        {
                            title: "Delete",
                            action: handleDelete,
                            icon: APP_ICONS.BIN,
                            isDelete: true
                        }
                    ]
                }
            })}
            loading={userQuery?.isLoading}
            totalResults={userQuery?.data?.totalResults}
            totalPages={userQuery?.data?.totalPages}
            pageNo={query.pageNo}
            pageSize={query.pageSize}
            onQueryChange={(updatedQuery) => setQuery({ ...query, ...updatedQuery })}
            query={query}
            onRefresh={() => userQuery.refetch()}
            isRefreshing={userQuery?.isFetching}
        />
    )
}

export default UserList